<template>
  <q-btn unelevated round>
    <q-icon size="md" name="person" />
    <!-- <q-avatar v-if="userProfiles" class="shadow-1">
      <img src="user-icon.jpg" class="q-pa-xs" />
    </q-avatar> -->

    <q-menu fit>
      <q-list style="min-width: 200px">
        <q-item v-if="whoAmI">
          <q-item-section>
            <div class="column">
              <p
                class="text-body1 text-weight-medium q-ma-xs"
                :class="chooseActiveTextColor()"
              >
                {{ `${whoAmI.first_name} ${whoAmI.last_name}` }}
              </p>
              <p class="q-ma-xs text-grey-7">
                {{ whoAmI.email }}
              </p>
              <p class="q-ma-xs text-grey-7">
                {{ whoAmI.phone_number }}
              </p>
            </div>
          </q-item-section>
        </q-item>
        <q-item
          v-if="whoAmI && theme == false"
          clickable
          @click="$router.push('/user-profile')"
        >
          <q-item-section>Profile</q-item-section>
        </q-item>
        <q-item
          v-if="whoAmI && theme == false"
          clickable
          @click="$router.push('/settings')"
        >
          <q-item-section>Settings</q-item-section>
        </q-item>
        <q-separator />
        <q-item clickable @click="logout">
          <q-item-section>Logout</q-item-section>
        </q-item>
      </q-list>
    </q-menu>
    <q-tooltip content="Uesr-Profile" class="bg-primary">
      User Profile
    </q-tooltip>
  </q-btn>
</template>

<script>
// import gravatar from "gravatar";
import { defineComponent } from "vue";
import { useRouter } from "vue-router";
import { useQuasar } from "quasar";
import { useStore } from "vuex";
import { ref } from "vue";

import useAccounts from "src/use/accounts";

export default defineComponent({
  name: "UserDropDown",
  props: {
    theme: { type: Boolean, default: false },
    whoAmI: {
      type: Object,
    },
  },

  setup() {
    const $q = useQuasar();
    const $router = useRouter();
    const userProfiles = ref(null);
    const $store = useStore();
    const logout = (evt) => {
      $store
        .dispatch("authenticate/logout")
        .then(() => {
          $store.commit("packages/updatePackageStatus", []);
          $router.push({ path: "/login" });

          $q.notify({
            type: "positive",
            message: "Logging Out",
          });
        })
        .catch((error) => {
          $router.push({ path: "/login" });
          $q.notify({
            type: "negative",
            message: error,
          });
        });
    };
    function chooseActiveTextColor() {
      if ($q.dark.mode === true) {
        return "grey-7";
      } else {
        if ($store.state.domain.domain == $store.state.domain.sweta)
          return "text-blue-grey";
        if ($store.state.domain.domain == "chukul.com") return "text-primary";
        if ($store.state.domain.domain == "prabhu") return "text-red";
        if ($store.state.domain.domain == $store.state.domain.arthasarokar)
          return "text-green";
      }
    }
    return {
      chooseActiveTextColor,
      logout,
      userProfiles,
      // gravatar,
    };
  },
});
</script>
